import { createSlice } from "@reduxjs/toolkit";

const homeSlice = createSlice({
    name: "home",
    initialState: {
        homeDetails: null,
        homeError: null,
        homeLoading: false,
    },
    reducers: {
        setHomeDetails: (state, { payload }) => {
            state.homeDetails = payload;
        },
        setHomeError: (state, { payload }) => {
            state.homeError = payload;
        },
        setHomeLoading: (state, { payload }) => {
            state.homeLoading = payload;
        },
    }
});

export const { setHomeDetails, setHomeError, setHomeLoading } = homeSlice.actions;

export default homeSlice.reducer;